export default function (context) {
    const { params, route, redirect } = context;
    if (params.slug && params.slug !== params.slug.toLowerCase()) {
      const lowercasePath = route.fullPath.toLowerCase();
      return redirect(301, lowercasePath);
    }
}
